import { type Session } from '@supabase/supabase-js'
import { createContext } from 'react'

export interface AuthSignInCredentials {
  email: string
  password: string
}

export interface AuthSignUpCredentials extends AuthSignInCredentials {
  firstName: string
  lastName: string
}

export interface AuthContextValue {
  isSigningIn: boolean
  isSigningOut: boolean
  isSigningUp: boolean
  refreshSession: () => Promise<void>
  session: Session | null
  signInWithApple: () => void
  signInWithCredentials: (credentials: AuthSignInCredentials) => void
  signInWithGoogle: () => void
  signOut: (cb?: () => void) => void
  signUpWithCredentials: (credentials: AuthSignUpCredentials) => void
}

export const AuthContext = createContext<AuthContextValue>({
  isSigningIn: false,
  isSigningOut: false,
  isSigningUp: false,
  refreshSession: Promise.resolve,
  session: null,
  signInWithApple: Promise.resolve,
  signInWithCredentials: Promise.resolve,
  signInWithGoogle: Promise.resolve,
  signOut: Promise.resolve,
  signUpWithCredentials: Promise.resolve
})
